import { RootState } from 'types/RootState.types';

export const shouldShowPOSCBasketExcess = (state: RootState): boolean => {
  const posCreditBasketLimitExceeded = state?.orderForm?.posCreditBasketLimitExceeded || false;
  const posCreditBasketExcess = state?.orderForm?.posCreditBasketExcess || 0;

  return posCreditBasketLimitExceeded && posCreditBasketExcess > 0;
};
